<template>
    <div v-loading="pageLoading">
        <div class="content-box account-info first">
            <div class="form-body">
                <el-form :model="formData" ref="formData" label-position="top">
                    <el-form-item
                        label="现用名"
                        prop="personName"
                        :rules="[
                            {required: true, message: '请输入现用名', trigger: 'blur'},
                            {regexp: /^[\u4e00-\u9fa5]{2,6}$/, message: '字数范围在2~6个，只能输入中文'},
                            {
                                validator: (rule, value, callback) => {
                                    if (value === oldUserData.adminUserName) {
                                        callback('与当前姓名一致，请重新输入');
                                    } else {
                                        callback();
                                    }
                                },
                            },
                        ]"
                    >
                        <el-input placeholder="请输入更改后的姓名" min="2" max="6" v-model="formData.personName"></el-input>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :rules="[{required: true, message: '请上传证件正面'}]" prop="idPhoto" label="证件正面">
                                <ImageUpload
                                    :size="10"
                                    fixedNumber="4:3"
                                    :url.sync="formData.idPhoto"
                                    accept="image/png,image/jpeg"
                                    @onSuccess="handleidPhotoSuccess"
                                >
                                    <div slot="tips">格式JPG、JPEG、PNG，不得大于10M</div>
                                </ImageUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :rules="[{required: true, message: '请上传证件背面'}]" prop="idPhoto2" label="证件背面">
                                <ImageUpload
                                    :size="10"
                                    :url.sync="formData.idPhoto2"
                                    fixedNumber="4:3"
                                    accept="image/png,image/jpeg"
                                    @onSuccess="handleidPhotoSuccess"
                                >
                                    <div slot="tips">格式JPG、JPEG、PNG，不得大于10M</div>
                                </ImageUpload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="form-tips" style="color: #606266">
                        1. 认证人必须年满18岁
                        <br />
                        2. 请上传本人清晰彩色完整的证件原件；
                        <br />
                        3. 照片应清晰可见容易识别，且边框完整；
                        <br />
                        4. 必须真实拍摄，不能使用复印件；
                        <br />
                        5. 仅支持 png、jpg、jpeg，大小不超过 10M
                        <br />
                        6.请上传姓名更正后的身份证
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item
                                prop="personIdCard"
                                :rules="[
                                    {required: true, message: '请输入身份证号', trigger: 'blur'},
                                    {
                                        validator: (rule, value, callback) => {
                                            if (value && value.toLowerCase() !== oldUserData.idNum.toLowerCase()) {
                                                callback('与系统保留的身份证号不一致，请重新上传身份证照片');
                                            } else {
                                                callback();
                                            }
                                        },
                                        trigger: ['blur', 'change'],
                                    },
                                ]"
                                label="身份证号"
                            >
                                <el-input placeholder="身份证号" disabled v-model="formData.personIdCard"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="认证电话">
                                <el-input placeholder="认证电话" disabled v-model="formData.telephone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div style="text-align: center">
                <el-button @click="onColse">取 消</el-button>
                <el-button type="primary" :loading="nextLoading" @click="onNext">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {MessageBox} from 'element-ui';
import ImageUpload from '@/components/ImageUpload';
export default {
    components: {
        ImageUpload,
    },
    data() {
        return {
            pageLoading: false,
            oldUserData: {
                adminUserName: '',
                idName: '',
                telephone: '',
            },
            formData: {
                personName: '',
                idPhoto: '',
                idPhoto2: '',
                personIdCard: '',
                telephone: '',
            },
            nextLoading: false,
            verifyState: 0, // 记录认证状态用于判断是否成功
            fddInfo: {},
            oldTransactionNo: null
        };
    },
    created() {
        this.getNameInfo();
    },
    methods: {
        handleidPhotoSuccess() {
            const {idPhoto, idPhoto2} = this.formData;
            if (idPhoto && idPhoto2) {
                // this.getIDCard();
                this.$refs['formData'].clearValidate(['idPhoto', 'idPhoto2']);
            }
        },
        // 身份证读取
        async getIDCard() {
            const {idPhoto, idPhoto2} = this.formData;
            if (!idPhoto || !idPhoto2) return;
            const response = await this.$request.post('/letSign/idCardDiscern', {backImage: idPhoto2, frontImage: idPhoto}, {formData: false});
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {personName, personIdCard} = result;
            if (personName && personIdCard) this.formData = {...this.formData, personName, personIdCard};
        },
        // 修改等待
        async waitConfirm(status, url, transactionNo) {
            const flag = await this.$fadadaConfirm('修改认证', '请确认是否完成了实名认证', status, url);
            if(flag == 'success'){
                const respnonse = await this.$request({
                    url: '/fabigbig/verifyFinish',
                    params: {transactionNo},
                    method: 'GET',
                });
                const {state, msg, result} = respnonse.data;
                if (!state) return this.$message.error(msg || '认证失败');
                //真正的认证成功
                if (result == false) {
                    MessageBox.confirm('认证信息更新可能会延迟1-2分钟，如果您确认认证成功，请您稍后刷新页面', '提示', {
                        confirmButtonText: '我知道啦',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {})
                        .catch(() => {});
                } else { 
                    this.getNameInfo();
                }
            }
            if (flag == 'refresh') this.getNameInfo();
        },
        onColse() {
            this.$router.go(-1);
        },
        // 获取用户信息
        async getNameInfo() {
            this.pageLoading = true;
            const response = await this.$request({
                url: '/fabigbig/personNameCertInfo',
                method: 'post',
            });
            const {state, msg, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.pageLoading = false;
            const {verifyName, idPhoto, idPhoto2, isVerify, telephone, idNum, verifyUrl, transactionNo} = result;
            this.oldTransactionNo = transactionNo;
            this.oldUserData = result;
            this.formData = {...this.formData, personName: verifyName, idPhoto, idPhoto2, telephone, personIdCard: idNum};
            this.fddInfo = result;
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            /**
             * 判断是否认证成功
             * 1、isVerify为0 未发起过认证 去修改姓名
             * 2、上一次认证已经完成 本次修改姓名
             */
            if (isVerify == 2 || (isVerify == 0 && isVerify !== this.verifyState)) {
                this.$message.success('姓名修改成功');
                await this.$store.dispatch('getUserInfo');
                return (window.location.href = '/manage/accountManage');
            }
            if (isVerify !== this.verifyState) this.verifyState = isVerify;
            //有事务编号 且 认证状态为 1 认证中
            if(this.oldTransactionNo && isVerify == 1) {
                this.waitConfirm([1,2] ? 2 : isVerify, verifyUrl, this.oldTransactionNo);
            }
        },
        // 修改用户名
        async realNameVerification() {
            if (this.fddInfo.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            const formData = JSON.parse(JSON.stringify(this.formData));
            this.nextLoading = true;
            const response = await this.$request.post('/fabigbig/personNameCert', formData, {formData: false});
            const {state, msg, result} = response.data;
            this.oldTransactionNo = result.transactionNo;
            this.nextLoading = false;
            if (!state) return this.$message.error(msg || '修改用户名失败');
            const flag = await this.$msgbox({
                title: '前往电子合同平台“法大大”',
                message: '即将前往电子合同平台“法大大”，在该平台，你将，完成实名认证。',
                confirmButtonText: '确认前往',
            });
            if (flag === 'cancel') return;
            result.verifyUrl && window.open(result.verifyUrl);
            this.getNameInfo();
        },
        onNext() {
            const { verificationPlatform } = this.$store.state;
            //当前是电子签 跳转到法大大认证页面
            if(verificationPlatform == 1){
                MessageBox.confirm('您需要重新认证后签约', '重新认证', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        const routerParams = JSON.stringify({
                            reVerifyType: 2,
                            personName: this.formData.personName,
                        });
                        sessionStorage["routerParams"] = routerParams;
                        this.$router.push(`/manage/contract/verify/fdd/step/1?reVerifyType=2`);
                    })
                    .catch(() => {
                        this.$router.go(-1);
                    });
            }
            //当前是法大大 走之前的逻辑
            else {
                this.$refs['formData'].validate(async (valid) => {
                    if (!valid) return;
                    this.realNameVerification();
                });
            }
        }
    },
};
</script>
<style lang="scss"></style>
